import React from 'react'

const Additional = () => {
    return (
        <div className='skills_content'>
            <h3 className="skills_title">Additional Skills</h3>

            <div className="skills_box">
                <div className="skills_group">
                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">Testing</h3>

                        </div>
                    </div>

                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">Security</h3>

                        </div>
                    </div>

                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">Soft Skills</h3>

                        </div>
                    </div>
                </div>

                <div className="skills_group">
                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">DSA</h3>

                        </div>
                    </div>


                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">DevOps</h3>

                        </div>
                    </div>


                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">Agile Methodologies</h3>

                        </div>
                    </div>
                </div>
            </div>










        </div>
    )
}

export default Additional
